// Generated by purs version 0.15.15
var Min = /* #__PURE__ */ (function () {
    function Min() {

    };
    Min.value = new Min();
    return Min;
})();
var Mid = /* #__PURE__ */ (function () {
    function Mid() {

    };
    Mid.value = new Mid();
    return Mid;
})();
var Max = /* #__PURE__ */ (function () {
    function Max() {

    };
    Max.value = new Max();
    return Max;
})();
var showAlign = {
    show: function (v) {
        if (v instanceof Min) {
            return "Min";
        };
        if (v instanceof Mid) {
            return "Mid";
        };
        if (v instanceof Max) {
            return "Max";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Align (line 16, column 10 - line 19, column 17): " + [ v.constructor.name ]);
    }
};
var printAlign = function (v) {
    if (v instanceof Min) {
        return "Min";
    };
    if (v instanceof Mid) {
        return "Mid";
    };
    if (v instanceof Max) {
        return "Max";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Align (line 22, column 14 - line 25, column 15): " + [ v.constructor.name ]);
};
var eqAlign = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Min && y instanceof Min) {
                return true;
            };
            if (x instanceof Mid && y instanceof Mid) {
                return true;
            };
            if (x instanceof Max && y instanceof Max) {
                return true;
            };
            return false;
        };
    }
};
export {
    Min,
    Mid,
    Max,
    printAlign,
    eqAlign,
    showAlign
};
